import { Card, CardContent } from "./ui/card";
import { WebYesLogoIcon } from "../icons/WebYesLogoIcon";
import { TickIcon } from "../icons/TickIcon";
import { FeatureItem } from "./FeatureItem";
import { PLUGIN_VERSION } from "@/helpers/plugin";

export const PromoBanner = () => {
  const features = [
    <>Check <strong>WCAG 2.1 and 2.2 Level A and AA</strong> compliance, with <strong>Level AAA</strong> checks in premium version.</>,
    <><strong>Prioritize issues</strong> based on the most affected pages, the most common issues, or their severity.</>,
    <><strong>Identify issue sources in real time</strong> using the <strong>Inspector</strong> feature.</>,
    <>Get <strong>AI-powered suggestions</strong> on how to fix accessibility problems.</>,
    <>Detect issues on <strong>both mobile and desktop</strong> versions of your pages.</>,
    <><strong>Schedule scans automatically</strong> <em>(available in premium plans only)</em>.</>,
  ];

  return (
    <Card
      style={{
        backgroundImage: `
          linear-gradient(rgba(44, 119, 226, 0.5) 1px, transparent 1px),
          linear-gradient(90deg, rgba(44, 119, 226, 0.5) 1px, transparent 1px)
          `,
        backgroundSize: "90px 90px",
      }}
      className="cy:py-0 cy:w-[309px] cy:bg-[#055FDD] cy:rounded-2xl cy:text-white cy:border-0 cy:relative"
    >
      {/* Grid lines background */}

      <CardContent className="cy:p-0 cy:flex cy:flex-col cy:gap-[46px]  cy:rounded-2xl cy:overflow-hidden">
        {/* Main content area */}
        <div className="cy:flex-1  cy:pt-[19px] cy:px-[19px]">
          {/* Header section with W logo - showing W directly */}
          <div className="cy:p-0 cy:mb-3">
            <WebYesLogoIcon width={90} height={44} />
          </div>

          {/* Main heading */}
          <h2 className="cy:text-2xl! cy:font-bold cy:mb-6 cy:leading-tight cy:text-white!">
            How Accessible Is Your Website?
          </h2>

          {/* Description */}
          <p className="cy:text-base! cy:opacity-90 cy:mb-8! cy:leading-relaxed">
            Check your accessibility score with WebYes. Run a quick audit to
            uncover accessibility issues that could be affecting your visitors —
            and your compliance.
          </p>

          {/* Features list */}
          <div className="cy:space-y-3">
            {features.map((feature, index) => (
              <FeatureItem
                key={index}
                icon={<TickIcon width={22} height={22} />}
                message={feature}
              />
            ))}
          </div>
        </div>

        {/* Bottom section with white button */}
        <div className="cy:mt-auto cy:bg-[#1B365D] cy:py-7 cy:pl-[19px] cy:pr-[19px] cy:rounded-2xl cy:text-center">
          <a
            href={`https://accessibility.webyes.com/trial?plan=accessibility_pro_monthly&utm_source=Pluginscreen&utm_medium=AccessibilityPlus&utm_campaign=PluginSignups&utm_content=${PLUGIN_VERSION}`}
            className="cy:w-full cy:bg-white cy:hover:bg-white/90!  cy:text-[#0251AF]! cy:font-bold cy:text-base! cy:px-7 cy:py-2 cy:rounded"
            target="_blank"
          >
            Audit My Site Now
          </a>
        </div>
      </CardContent>
    </Card>
  );
};
